/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import TourComponent from '@/componentWebs/vietnamTickets/TourComponent';
import SliderQuangCao from '@/componentWebs/vietnamTickets/SliderQuangCao';
import BoxSearchFlignhts from '@/componentWebs/vietnamTickets/BoxSearchFlignhts';
import ProvincesCarosel from '@/componentWebs/Common/ProvincesCarosel';

// import 'moment/locale/vi_VN';
// import locale from 'antd/';

import moment from 'moment';

moment.locale('vi');

@connect(({ webs: { dataAd } }) => ({
  dataAd,
}))
class Index extends Component {
  state = {
    isInternational: '0',
  };

  handleInternational = status => {
    this.setState({
      isInternational: status,
    });
  };

  render() {
    const { isInternational } = this.state;
    const { data } = this.props;
    const template =
      data.templateLayouts && data.templateLayouts.templates && data.templateLayouts.templates[0];
    const imageResize =
      template && template.templateLayoutTemplates && template.templateLayoutTemplates.imagesResize;

    return (
      // Tin tức trang chủ
      <React.Fragment>
        <div className="hidden-m-t">
          <SliderQuangCao {...this.props} type="tour" />
        </div>

        <div className="hidden-pc">
          <ProvincesCarosel key={isInternational} typesId="4" isInternational={isInternational} />
        </div>

        <div className="container-normal bannerMobile">
          <BoxSearchFlignhts getIsInternational={this.handleInternational} typeTab="tour" />
        </div>

        <div className="hidden-pc">
          <SliderQuangCao {...this.props} type="tour" />
        </div>

        <section className="khachSan tour">
          <div className="container-normal ">
            {/* dia diem (dang de tam an)  */}
            <div className="hidden-m-t">
              <ProvincesCarosel key={isInternational} typesId="4" isInternational={isInternational} />
            </div>
            {/* Product khach san  */}
            <TourComponent isInternational={isInternational} imageResize={imageResize} />
          </div>

          <div className="pagiTuyenBay-top hidden-pc" />

        </section>
      </React.Fragment>
    );
  }
}

export default Index;
